<template>
  <div class="header">
    <a @click="home" class="navbar-brand">{{ title }}</a>
    <div class="head-cont">
      <SearchPanel></SearchPanel>
      <nav class="nav-links">
        <!-- <div class="nav-item">
          <a href="https://q.qq.com/wiki/develop/game/frame/config/" target="_blank" class="nav-link">小游戏开发文档</a>
        </div> -->
        <div class="nav-item">
          <a href="https://q.qq.com/channel/manage/" target="_blank" class="nav-link">渠道管理端</a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import SearchPanel from '@/components/search-panel';

export default {
  name: 'Header',
  components: {
    SearchPanel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    home() {
      location.href = '/sdk/wiki';
    },
  },
};
</script>
